import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { v4 as uuidv4 } from 'uuid';

import { ITsaScreener, IUser } from '../../../globals/interfaces';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { getTsDate } from '../../../utils';
import { createTsaScreenerSchema } from './yupSchema';
import FormInput from '../../../components/custom/hookForm/FormInput';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    handleAddScreener: (data: Omit<ITsaScreener, 'id'>) => Promise<void>;
    user: IUser;
}

export default function ModalAddScreener({
    modal,
    setModal,
    handleAddScreener,
    user
}: Props) {

    const {
        formState: {
            errors,
            isValid
        },
        reset,
        register,
        handleSubmit
    } = useForm<ITsaScreener>({
        mode: 'all',
        resolver: yupResolver(createTsaScreenerSchema)
    });

    const getPin = () => {
        const str = uuidv4();
        const array = [];
        for (const char of str) {
            if (!isNaN(char)) {
                array.push(char);
                if (array.length == 4) break;
            }
        }
        return array.join('');
    }


    useEffect(() => {
        const barcodeNumber = uuidv4();
        reset({
            name: '',
            ccsfk9: '',
            barcodeNumber,
            pin: getPin(),
            active: true,
            unit: user.s_unit,
            createdBy: user.s_email,
            createdAt: getTsDate(),
            modifiedBy: user.s_email,
            modifiedAt: getTsDate()
        });
    }, [modal, user]);

    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Add Screener</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FormInput<ITsaScreener>
                    register={register}
                    label={'Name'}
                    errors={errors}
                    name={'name'}
                />
                <FormInput<ITsaScreener>
                    register={register}
                    label={'CCSF K9'}
                    errors={errors}
                    name={'ccsfk9'}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'save'} 
                            onClick={handleSubmit(handleAddScreener)} 
                            disabled={!isValid}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;